import { StepConnector as MUIStepConnector, styled } from '@mui/material'
import useGetStepConnectorTemplate
  from '~/src/components/mui-wrappers/styled/step-connector/styles/useGetStepConnectorTemplate'

const StepConnector = styled(MUIStepConnector)(() => (useGetStepConnectorTemplate().getComponentSx()))

export default StepConnector
